'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RuleTypes = require('../constants/RuleTypes');

exports.default = (0, _immutable.Record)({
  assignmentStrategy: _RuleTypes.AssignmentTypes.UNASSIGNED,
  teamIds: (0, _immutable.List)()
}, 'SpecificTeamsAssignment');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/SpecificTeamsAssignment.js
// module id = 915
// module chunks = 2 3